import Image from "next/image";
import { getStrapiMedia } from "@/utils/api-helpers";

export interface ExperienceCardProps {
  id: number;
  name: string;
  description: string;
  tags: string[];
  createdAt: string;
  thumbnail: {
    url: string;
    alternativeText: string | null;
  };
  link?: {
    href: string;
    target: string;
  };
}

export default function ExperienceCard({
  name,
  description,
  tags,
  createdAt,
  thumbnail,
  link,
}: ExperienceCardProps) {
  return (
    <div className="flex flex-col h-full rounded-2xl overflow-hidden transition-all hover:scale-105 hover:cursor-pointer">
      <a
        href={link?.href}
        target={link?.target || "_self"}
        rel="noopener noreferrer"
        className="flex flex-col col-span-1"
      >
        <div className="relative">
          {tags[0] && (
            <div className="absolute top-5 left-5 border-[1px] border-white py-0 px-4 rounded-md z-[1]">
              <span className="text-white mb-0 font-medium uppercase text-sm ">
                {tags[0]}
              </span>
            </div>
          )}
        </div>

        <div className="relative">
          <div className="relative flex flex-col">
            <div className="absolute top-0 right-0 bottom-0 left-0 w-full h-[50%] bg-gradient-to-b from-[#00000080] to-transparent z-0 pointer-events-none" />
            <Image
              src={getStrapiMedia(thumbnail.url)}
              alt={thumbnail?.alternativeText || name}
              width={500}
              height={400}
              className="w-full object-cover"
              loading="lazy"
            />
          </div>
        </div>
        <div className="bg-white px-5 pt-3 flex flex-col flex-grow">
          <p className="text-purple font-medium text-sm mb-2">
            {/* {formatDate(createdAt)} */}
          </p>
          <h3 className="text-darkGrey2 text-lg lg:text-xl line-clamp-1 2xl:line-clamp-2 pb-1">
            {name}
          </h3>
          <p className="text-sm text-gray-700 line-clamp-3 ">
            {description}
          </p>
        </div>
      </a>
    </div>
  );
}
